import { css } from 'styled-components';
import SVGInline from 'components/SVGInline/SVGInline';
import { DropdownContent, DropdownItemSimpleWrapper } from 'components/DropdownMenu/DropdownMenu.css';
import { styled } from '../../ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ, MQ_NOT_TOUCH } from '../../../style/styled-components/cssMediaQueries';
import { InputFieldWithPlaceholder } from '../../InputFieldWithPlaceholder/InputFieldWithPlaceholder';
import { Input, Placeholder } from '../../InputFieldWithPlaceholder/InputFieldWithPlaceholder.css';

const animationType = 'ease';
export const animationDuration = '400ms';

export const IconSearch = styled(SVGInline)<{ $isOpen: boolean }>`
    width: 24px;
    height: 24px;
    transition: none;
    cursor: pointer;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${(props) => (props.$isOpen ? 'initial' : 'absolute')};
    margin-top: 0;

    ${(props) =>
        props.$isOpen
            ? ''
            : css`
                  top: 6px;
                  left: 6px;
              `}

    ${MQ(Breakpoints.m)} {
        transition: all ${animationDuration} ${animationType};
    }

    svg {
        path {
            fill: ${(props) => (props.$isOpen ? 'rgba(235, 235, 241, 0.70)' : props.theme.brandedConfig.high_contrast)};
        }
    }

    &:hover {
        opacity: 0.7;
    }

    &:focus-visible {
        outline: var(--focus-outline);
        border-radius: 50%;
        outline-offset: 4px;
        transition: none !important;
    }
`;

export const IconClear = styled(SVGInline)`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    transition: none;
    z-index: 1;

    svg {
        display: block;

        path {
            fill: rgba(235, 235, 241, 0.7);
        }
    }

    ${MQ(Breakpoints.m)} {
        transition: all ${animationDuration} ${animationType};
        right: 11px;
    }
`;

export const ButtonClose = styled.a`
    display: block;
    float: right;
    width: 0;
    overflow: hidden;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    transition: none;

    ${MQ(Breakpoints.m)} {
        transition: all ${animationDuration} ${animationType};
    }
`;

export const SearchInputContainer = styled.div`
    position: static;
    display: flex;
    align-items: center;
    float: right;
    padding: 4px 8px;
    width: 0;
    transition: none;
    border-radius: 4px;

    &:has(input:focus) {
        outline: var(--focus-outline-solid);
        outline-offset: 2px;
    }

    ${MQ(Breakpoints.m)} {
        transition: all ${animationDuration} ${animationType};
    }
`;

export const SearchInputLabel = styled.label`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;

export const SearchInput = styled(InputFieldWithPlaceholder)`
    display: block;
    height: 100%;
    outline: none;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;

    ${Input} {
        line-height: 23px;
        border: none;
        outline: none;
        height: 100%;
        width: 100%;
        color: ${(props) => props.theme.brandedConfig.high_contrast};
        font-size: 16px;
        font-family: inherit;
    }

    ${Placeholder} {
        color: rgba(235, 235, 241, 0.7);
        top: 4px;
        font-size: 16px;
        font-family: inherit;
    }

    ${MQ(Breakpoints.m)} {
        ${Input} {
            background-color: transparent;
        }
    }
`;

export const SearchWrapper = styled.div<{ isOpen: boolean; closing: boolean }>`
    float: right;
    position: relative;
    transition: none;
    width: 36px;
    height: 36px;
    margin-right: 0;

    @-moz-document url-prefix() {
        top: 1px;
    }

    ${MQ(Breakpoints.m)} {
        transition: all ${animationDuration} ${animationType};
    }

    ${MQ(Breakpoints.m)} {
        background-color: transparent;
    }

    ${(props) =>
        props.isOpen && !props.closing
            ? css`
                  width: 100%;
                  margin-right: 0;
                  right: 0;
                  z-index: 2;

                  ${MQ(Breakpoints.m)} {
                      position: relative;
                      width: 295px;
                  }

                  ${SearchInputContainer} {
                      position: relative;
                      height: 100%;
                      width: calc(100% - 82px);
                      background: var(--color-dark-foreground);

                      ${MQ(Breakpoints.m)} {
                          width: 100%;
                      }
                  }

                  ${SearchInput} {
                      ${Input} {
                          /* padding: 5px 44px 5px 38px; */

                          ${MQ(Breakpoints.m)} {
                              /* padding: 5px 20px 5px 0; */
                          }
                      }

                      ${Placeholder} {
                          left: 38px;
                          width: calc(100% - 70px);

                          ${MQ(Breakpoints.m)} {
                              left: 0;
                              width: 100%;
                          }
                      }
                  }

                  ${IconSearch} {
                      right: calc(100% - 30px);

                      ${MQ(Breakpoints.m)} {
                          right: 100%;
                          margin-right: 10px;
                      }
                  }

                  ${IconClear} {
                      opacity: 1;
                  }

                  ${ButtonClose} {
                      width: 82px;

                      ${MQ(Breakpoints.m)} {
                          width: 0;
                      }
                  }
              `
            : ``}
`;

export const SearchHistoryDropdownWrapper = styled.div`
    ${DropdownContent} {
        width: 300px;
    }

    ${DropdownItemSimpleWrapper} {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        min-height: 44px;

        .search-history {
            position: relative;
            top: 0;
            transform: none;
            right: 0;
            width: 20px;
            height: 20px;

            svg {
                position: relative;
                width: auto;
                height: 100%;
            }
        }

        .delete-history {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 24px;
            width: 24px;
            margin-right: 16px;

            svg {
                width: 14px;
                height: 14px;
            }
        }
    }
`;

export const DropdownHistoryText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    width: 75%;
    white-space: nowrap;
    max-width: 250px;
`;

export const DropdownTitle = styled(DropdownItemSimpleWrapper)`
    font-weight: bold;
    opacity: 1;
    color: ${(props) => props.theme.brandedConfig.white_color};

    ${MQ_NOT_TOUCH} {
        &:hover {
            background-color: transparent;
        }
    }
`;
